function check_product() {
  console.log('check_product() called');

  // Prevent duplicate intervals if this function is called more than once.
  if (window.__deliveryCalendarInterval) {
    clearInterval(window.__deliveryCalendarInterval);
  }

  // Get today's date in Sydney, Australia.
  function getSydneyDateOffset(offsetDays) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Australia/Sydney',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        values[part.type] = part.value;
      }
    });

    const date = new Date(Date.UTC(
      Number(values.year),
      Number(values.month) - 1,
      Number(values.day) + offsetDays
    ));

    return date.toISOString().slice(0, 10);
  }

  // Disable a specific calendar date using its full YYYY-MM-DD value.
  function disableCalendarDate(isoDate) {
    document.querySelectorAll(
      '.rmdp-day span[aria-label]'
    ).forEach(function (span) {
      if (span.getAttribute('aria-label') !== isoDate) {
        return;
      }

      const dayElement = span.closest('.rmdp-day');

      if (!dayElement) {
        return;
      }

      // Leave restrictions applied by the delivery app untouched.
      if (dayElement.classList.contains('rmdp-disabled')) {
        return;
      }

      dayElement.classList.add('rmdp-disabled');
      span.setAttribute('aria-disabled', 'true');
      span.setAttribute('tabindex', '-1');

      // Track restrictions added by this custom code.
      dayElement.dataset.customRestriction = 'true';
    });
  }

  // Run repeatedly because the delivery app may re-render its calendar.
  window.__deliveryCalendarInterval = setInterval(function () {
    // Read product tags.
    const productTags = Array.from(
      document.querySelectorAll('p.tags')
    ).map(function (element) {
      return element.textContent.toLowerCase().trim();
    });

    const isCorporateCatering = productTags.some(function (tag) {
      return tag.includes('corporate&catering');
    });

    const isNextDay = productTags.some(function (tag) {
      return tag.includes('nextday');
    });

    const isBuildPickup = productTags.some(function (tag) {
      return tag.includes('build') && tag.includes('pickup');
    });

    const isBuildDelivery = productTags.some(function (tag) {
      return tag.includes('build') && !tag.includes('pickup');
    });

    /*
     * CORPORATE & CATERING:
     * Disable today, tomorrow and the day after tomorrow.
     */
    if (isCorporateCatering) {
      disableCalendarDate(getSydneyDateOffset(0));
      disableCalendarDate(getSydneyDateOffset(1));
      disableCalendarDate(getSydneyDateOffset(2));
    }

    /*
     * NEXTDAY:
     * Disable today only.
     */
    if (isNextDay) {
      disableCalendarDate(getSydneyDateOffset(0));
    }

    /*
     * BUILD PRODUCTS:
     * Hide the irrelevant time-slot option.
     *
     * This is independent of the calendar logic, so a missing
     * dropdown won't stop the calendar restrictions from running.
     */
    const parentDiv = document.querySelector(
      '.rc-virtual-list-holder-inner'
    );

    if (parentDiv) {
      const pickupElement = parentDiv.querySelector(
        '.ant-select-item-option[title=" 02:00 PM to 06:30 PM - Pickup only"]'
      );

      const deliveryElement = parentDiv.querySelector(
        '.ant-select-item-option[title=" 09:00 AM to 05:00 PM  - For Delivery"]'
      );

      if (isBuildPickup && deliveryElement) {
        deliveryElement.style.display = 'none';
      }

      if (isBuildDelivery && pickupElement) {
        pickupElement.style.display = 'none';
      }
    }
  }, 500);
}

/*function check_product() {
  console.log('check_product() called');
  var check_prod = setInterval(function() {
    // This function is being executed repeatedly at regular intervals
    // (the interval is set by the setInterval function, which is set to 500 milliseconds)

    // Create an array to store product names
    var product_names = [];
    
    // Use jQuery to select all elements with class "tags" and get the inner text of each
    $('p.tags').each(function() {
      var innerText = $(this).text();
      // Push the inner text into the product_names array
      product_names.push(innerText);
    });
    
    // Define the search text we want to look for in the product_names array
    var searchText = "corporate&catering";
    var nextday = "nextday"; //change this with 'nextday' 
    
    // Calculate the dates that we want to disable in the date picker
    var day1_to_disabled = parseInt(dd) + 1;
    var day2_to_disabled = parseInt(dd) + 2;

    //console.log(product_names)

    
    // Find the parent div element - hide/show delivery and pickup time based on what build your own box is on the cart,
    var parentDiv = document.querySelector('.rc-virtual-list-holder-inner');
    if (!parentDiv) {
    return; // Stop execution if it's not in the DOM yet
}
    // Find the child element with "Pickup only" and hide it
    var pickupElement = parentDiv.querySelector('.ant-select-item-option[title=" 02:00 PM to 06:30 PM - Pickup only"]');
    // Find the child element with "For Delivery" and show it
    var deliveryElement = parentDiv.querySelector('.ant-select-item-option[title=" 09:00 AM to 05:00 PM  - For Delivery"]');

    
    product_names.forEach(function(name) {

      
      // Check if the current product is belong to corporate&catering products
      if (name.includes(searchText)) {
        //console.log('search product is exist')
        $('.rmdp-day').each(function() {
          var dateText = $(this).find('span.sd').text();
          //console.log(dateText + " = " + dd);
          // Check if the date text is equal to 'dd', 'day1_to_disabled', or 'day2_to_disabled'
          if (dateText == dd || dateText == day1_to_disabled || dateText == day2_to_disabled) {
            $(this).closest('div').addClass('rmdp-disabled');
            //console.log('disabled the date - '+ dateText);
          }
        });

        // Check if the value of the first element in the datepick array includes dd, day1_to_disabled, or day2_to_disabled
        if (datepick[0].value.includes(dd) || datepick[0].value.includes(day1_to_disabled) || datepick[0].value.includes(day2_to_disabled)) {
           //If the value of the first element in the datepick array matches one of the disabled dates, clear its value
          datepick[0].value = "";
           //Reset the class of the first element with class "ui-state-default ui-state-active" to "ui-state-default"
          document.getElementsByClassName("rmdp-day rmdp-selected")[0].className = 'rmdp-day';
        }
      }

      //check if the current product is belong to "not available for sameday delivery"
      if (name.includes(nextday)){
        //console.log('product in the cart is under nextday')
        $('.rmdp-day').each(function() {
          var dateText = $(this).find('span.sd').text();
          //console.log(dateText + " = " + dd);
          // Check if the date text is equal to 'dd', 'day1_to_disabled', or 'day2_to_disabled'
          if (dateText == dd) {
            // If the date text matches one of the disabled dates, use jQuery to add class "rmdp-disabled" to the closest "div" element
            $(this).closest('div').addClass('rmdp-disabled');
            //console.log('disabled the date - '+ dateText);
          }
        });

        const dateStr = datepick[0].value; // Assuming datepick[0].value holds the date string like "24/08/2023"
        const day = dateStr.split('/')[0]; // Extracting the day part
        if (day == dd) {
          //console.log('datepick:'+day + '=' + dd +':datetoday DD' )
          datepick[0].value = "";
          var selectedDate = document.getElementsByClassName("rmdp-day rmdp-selected")[0];
          if (selectedDate){
            selectedDate.className  = 'rmdp-day';
          }
        }
      }

      //check if product is belong to build your own box store pickup
      if (name.includes("build")){
        if (name.includes("pickup")){
          if (deliveryElement) {
              deliveryElement.style.display = 'none';
          }
        }else{
          if (pickupElement) {
              pickupElement.style.display = 'none';
          }
        }
        
      }

      
    });
  }, 500);
}

*/